import React from "react";
import { connect } from 'react-redux';
import { Line } from 'react-chartjs-2';
import moment from 'moment'
import lodash from 'lodash'

class chartActiveUser extends React.Component {

  render() {
    let { startDate, endDate, activeUser, tableDatas } = this.props
    const nextLoopCondition = (activeUser === 'monthly')? 'months': 'days'
    const labelsFormat = (activeUser === 'monthly')?'MMMM YYYY':'DD-MMM-YY'
    const findDataFormat = (activeUser === 'monthly')?'YYYY-MM':'YYYY-MM-DD'
    let labels = []
    let chartdata = []

  
    const apiData = tableDatas
    for (var m = moment(startDate); m.diff(endDate, 'days') <= 0; m.add(1, nextLoopCondition)) {
      let result = lodash.find(apiData, { reportDate: m.format(findDataFormat) })
    
      if(result){
        chartdata.push(parseInt(result.count))
      }else{
        chartdata.push(0)
      }

      labels.push(m.format(labelsFormat))
    }

    
    const data = {
      labels: labels,
      datasets: [
        {
          label: 'Active User',
          fill: false,
          lineTension: 0,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(75,192,192,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 0,
          pointHoverRadius: 0,
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 2,
          pointHitRadius: 5,
          data: chartdata
        }
      ]
    }

    return (
      <>
        <Line data={data} options={{
          maintainAspectRatio: true,
          legend: false,
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Total User'
              },
              ticks: {
                maxTicksLimit: 10,
                beginAtZero: true,
                stepSize: 1,
                callback: function(value) {
                  return parseInt(value)
                }
              }
            }]
          },
        }}/>
      </>
    )
  }
}

chartActiveUser = connect(state => {
  const dashboard = state.dashboard
  const startDate = lodash.get(dashboard, 'tableFilter.search.startDate')
  const endDate = lodash.get(dashboard, 'tableFilter.search.endDate')
  const activeUser = lodash.get(dashboard, 'tableFilter.search.type')

  return {
    activeUser, startDate, endDate
  }
})(chartActiveUser)

export default chartActiveUser